module.exports = __webpack_public_path__ + "img/publicidad.a328088a.png";